var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getFavoriteScenes.length)?_c('fab',{attrs:{"main-icon":"scene-lg","position":"bottom-right","bg-color":_vm.bgColor,"actions":_vm.getFavoriteScenesForFAB,"fixed-tooltip":true},on:{"click":_vm.invokeScene}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }